module.exports = __webpack_public_path__ + "static/pigly01-9b63e3a5468faa1c2bd1e3895bdbac8f.png";